export const environment = {
  name: 'deploy',
  production: true,
  local: false,
  testing: false,
  pullRates: {
    notifications: 5000,
    maintanceMode: 5000,
    volatileSettings: 2000,
    assetLocks: 5000,
  },
  visualRenderTimeout: 2 * 60 * 1000,

  devLogLevels: false,
  logLevels: {
    debug: false,
    info: false,
    warn: false,
    error: true,
    categories: {
    }
  }
};
